import React, { useEffect } from 'react'
import Header from './header/Header'
import Footer from './footer/Footer'
import { Script } from 'gatsby'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Layout = ({ children }) => {
	useEffect(() => {
		AOS.init({
			duration: 800,
			once: true,
		})

	}, [])

	return <>
		<Header />

		<main className="relative">
			{children}
		</main>

		<Footer />

		<Script
			src="https://aws.predictiveresponse.net/trac.js"
			onLoad={() => <Script>{`trackPredictive();`}</Script>}
		/>
	</>

}

export default Layout
